import { Config } from '@/config';
import { LOCALE } from '@/util/i18n/locale';
import Vue from 'vue';

const getBeaconId = (locale) => (locale === LOCALE.EN_CA ? Config.beacon.en : Config.beacon.fr);

export const beaconStatus = Vue.observable({
  opened: 'false',
});

// Help Scout - Beacon
export const Beacon = {
  initialize() {
    if (window.Beacon) {
      this.initialized = true;
      window.Beacon('destroy');
      window.Beacon('init', this.beaconId);
      window.Beacon('config', {
        showPrefilledCustomFields: true,
      });
      window.Beacon('on', 'open', () => {
        beaconStatus.opened = true;
      });
      window.Beacon('on', 'close', () => {
        beaconStatus.opened = false;
      });
    }
  },
  toggle() {
    this.loadScripts();

    if (this.initialized) {
      window.Beacon('toggle');
    } else {
      this.initialize();
      window.Beacon('toggle');
    }
  },
  setLocale(locale) {
    this.beaconId = getBeaconId(locale);

    if (window.Beacon) {
      window.Beacon('close');

      this.initialized = false;
    }
  },
  updateUrl(url, title) {
    if (window.Beacon) {
      window.Beacon('close');
      window.Beacon('event', {
        type: 'page-viewed',
        url,
        title,
      });
      window.Beacon('suggest');
    }
  },
  prefill({ firstName, lastName, email }) {
    if (window.Beacon) {
      window.Beacon('prefill', {
        name: firstName + ' ' + lastName,
        email: email,
      });
    }
  },
  navigate(mode) {
    if (window.Beacon) {
      window.Beacon('navigate', `/${mode}/`);
    }
  },
  reset() {
    if (window.Beacon) {
      window.Beacon('reset');
    }
  },
  loadScripts() {
    if (this.scriptLoaded) return;

    /* eslint-disable */
    !(function (e, t, n) {
      function a() {
        var e = t.getElementsByTagName('script')[0],
          n = t.createElement('script');
        (n.type = 'text/javascript'),
          (n.async = !0),
          (n.src = 'https://beacon-v2.helpscout.net'),
          e.parentNode.insertBefore(n, e);
      }
      if (
        ((e.Beacon = n = function (t, n, a) {
          e.Beacon.readyQueue.push({ method: t, options: n, data: a });
        }),
        (n.readyQueue = []),
        'complete' === t.readyState)
      )
        return a();
      e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1);
    })(window, document, window.Beacon || function () {});
    /* eslint-enable */

    this.scriptLoaded = true;
  },
};
